import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import pic11 from '../assets/images/pic11.jpg'
import people from '../assets/images/people.jpg'
import peoplelogo from '../assets/images/peoplelogo.png'

const Generic = (props) => (
    <div>
        <Helmet>
            <title>PEOPLE AGENCY</title>
            <meta name="description" content="Generic Page" />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header>
                        <span className="image midlogo"><img src={peoplelogo} alt=""/></span>
                    </header>
                    <span className="image main"><img src={people} alt="" /></span>
                    <p>Previamente denominada MM+A e com 16 anos de experiência, a People é uma agência criativa centrada no branding e marketing digital, oferecendo também serviços web, comunicação offline e audiovisual.</p>
                    <center><a href="http://www.people-agency.com/" className="button">Saber mais</a></center>

                </div>
            </section>
        </div>
    </div>
)

export default Generic


// WEBPACK FOOTER //
// ./src/pages/people.js